import { pluginFactory } from '@atlaskit/editor-common/utils';

import { aiSmartButtonAPIKey } from './ai-smart-button-api-plugin-key';
import { reducer } from './reducer';
// eslint-disable-next-line import/order
import type { AISmartButtonAPIState } from './states';
// eslint-disable-next-line import/order
import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
// eslint-disable-next-line import/order
import type { Command } from '@atlaskit/editor-common/types';
// eslint-disable-next-line import/order
import type { EditorState, SafeStateField, Transaction } from '@atlaskit/editor-prosemirror/state';

export const createInitialState = (): AISmartButtonAPIState => {
	return {};
};

const dest = pluginFactory(aiSmartButtonAPIKey, reducer, {});
export const createPluginState: (
	dispatch: Dispatch,
	initialState: AISmartButtonAPIState | ((state: EditorState) => AISmartButtonAPIState),
) => SafeStateField<AISmartButtonAPIState> = dest.createPluginState;
export const createCommand: <A = unknown>(
	action: A | ((state: Readonly<EditorState>) => false | A),
	transform?: (tr: Transaction, state: EditorState) => Transaction,
) => Command = dest.createCommand;
export const getPluginState: (state: EditorState) => AISmartButtonAPIState = dest.getPluginState;
